import { useState } from "react";
import {
  Dialog,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Delete } from "@mui/icons-material";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../../App/Components/Modals/ConfirmationModal";
import { callAPI } from "../../../App/Helpers/callApi";
import Signifier from "../../../App/Components/Signifier/Signifier";
import {
  deleteTrackingPixel,
  getTrackingPixels,
} from "../TrackingPixelService";
import { TrackingPixelType } from "../../../App/Enums/TrackingPixels";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },

  tableCell: {
    [theme.breakpoints.down("md")]: {
      width: "auto",
    },
    width: "300px",
  },
}));

export default function TrackingPixelTableCell(props) {
  const classes = useStyles(props);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);

  function deleteGroup() {
    callAPI(
      deleteTrackingPixel(props.element.id),
      "Pixel Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getTrackingPixels(props.element.clientId).then((response) => {
        response.forEach(
          (row) =>
            (row.typeName =
              TrackingPixelType[
                Object.keys(TrackingPixelType).find(
                  (key) => TrackingPixelType[key]?.val === row.type
                )
              ].name)
        );
        props.setTableData(response);
      });
    });
  }

  function openDeleteModal(e) {
    e.preventDefault();
    setDeleteModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        component={Link}
        to={{
          pathname: "/trackingpixels/trackingpixeldetailed",
          state: props.element,
        }}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Delete" ? (
              <Tooltip title="Delete Pixel">
                <IconButton onClick={(e) => openDeleteModal(e)} size="large">
                  <Delete />
                </IconButton>
              </Tooltip>
            ) : (
              props.element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this tracking pixel?"
          func={() => deleteGroup()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
    </>
  );
}
